var _defs, _rect, _rect2, _path, _path2, _path3, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _circle, _circle2, _circle3, _circle4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAgentFarmIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 470 336",
    preserveAspectRatio: "xMidYMid slice",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "parcels",
    width: 73,
    height: 67,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 30,
    height: 27,
    rx: 3,
    fill: "#e0e8d9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 4,
    width: 30,
    height: 27,
    rx: 3,
    fill: "#e3eadc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 36,
    width: 30,
    height: 27,
    rx: 3,
    fill: "#e3eadc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 36,
    width: 30,
    height: 27,
    rx: 3,
    fill: "#e0e8d9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "map-home"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -13,
    y: -13,
    width: 26,
    height: 26,
    rx: 7,
    fill: "#fff",
    stroke: "#aac299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-7 0 7-6 7 6v7H3V2h-6v5h-4Z",
    fill: "none",
    stroke: "#62804e",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "selected-home"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 24,
    fill: "#d4e6c2",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#326349",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-8 0 8-7 8 7v8H3V2h-6v6h-5Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 470,
    height: 336,
    fill: "#edf3e9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 530,
    height: 390,
    fill: "url(#parcels)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-40 200 510 53M75-30l95 398M292-30l95 398M-30 319 495 178",
    stroke: "#f7f9f3",
    strokeWidth: 15,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-40 200 510 53M75-30l95 398M292-30l95 398M-30 319 495 178",
    stroke: "#dce5d4",
    strokeWidth: 1.2,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171 56 332 60 369 181 288 241 151 203 119 116Z",
    fill: "#c7dcae",
    fillOpacity: 0.48,
    stroke: "#809e65",
    strokeWidth: 1.6,
    strokeDasharray: "5 5"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 69,
    y: 117
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 106,
    y: 231
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 397,
    y: 92
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 410,
    y: 189
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 181,
    y: 96
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    href: "#map-home",
    x: 302,
    y: 190
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    href: "#selected-home",
    x: 254,
    y: 90
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    href: "#selected-home",
    x: 202,
    y: 179
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    href: "#selected-home",
    x: 321,
    y: 132
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 56,
    r: 3.5,
    fill: "#fff",
    stroke: "#809e65"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 332,
    cy: 60,
    r: 3.5,
    fill: "#fff",
    stroke: "#809e65"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 369,
    cy: 181,
    r: 3.5,
    fill: "#fff",
    stroke: "#809e65"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 119,
    cy: 116,
    r: 3.5,
    fill: "#fff",
    stroke: "#809e65"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentFarmIllustration);
export default __webpack_public_path__ + "static/media/agent-farm-illustration.6010dbdd6299d41e6d1a910e41fcc1a9.svg";
export { ForwardRef as ReactComponent };